<template>
    <div class="event_stats_bar flex_box">
        <section v-if="listData.length" class="affect_stats">
            <div class="toolBox mb12 flex_box justify-content_flex-end">
                <p class="co_FB7361 flex_box align-items_center fs10"><span class="bg_FB7361"></span><span>敏感事件</span></p>
                <p class="co_FEBB32 flex_box align-items_center fs10"><span class="bg_FEBB32"></span><span>中性事件</span></p>
                <p class="co_65DE8E flex_box align-items_center fs10"><span class="bg_65DE8E"></span><span>正面事件</span></p>
            </div>
            <div v-for="item in listData" :key="item.name"  style="position: relative;">
                <div class="listItem flex_box align-items_center line42">
                    <span class="titleLabel fs12 co_000">{{ item.name }}</span>
                    <div class="topBarBox barBoxBg flex_box co_666">
                        <p :style="{ width: item.negativePer + '%' }"></p>
                        <p :style="{ width: item.neutralPer + '%' }"></p>
                        <p :style="{ width: item.positivePer + '%' }" :class="!item.negativePer && !item.neutralPer ? 'positivePerBox_1' : !item.positivePer ? '' : 'positivePerBox_2'"></p>
                    </div>
                    <div class="lowerBarBox barBoxText flex_box co_666 text_c line20">
                        <p v-show="item.negativePer > 0" class="fs10" :style="{ width: item.negativePer + '%', marginRight: getMarginRight(item, 'negativePer') }">{{ formatPercentStr(item,"negativePer") }}%</p>
                        <p v-show="item.neutralPer > 0" class="fs10" :style="{ width: item.neutralPer + '%', marginRight: getMarginRight(item, 'neutralPer'), marginLeft: getMarginLeft(item, 'neutralPer')  }">{{ formatPercentStr(item,"neutralPer") }}%</p>
                        <p v-show="item.positivePer > 0" class="fs10" :style="{ width: item.positivePer + '%' }">{{ formatPercentStr(item,"positivePer") }}%</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="chartBox count_stats" v-if="listData.length">
            <p v-bind:class="'affect_line_height_'+ listData.slice(0,5).length" class="lineBox"></p>
            <div class=" flex_box text_c co_666 ml8">
                <section class="flex_1">
                    <p class="fs10 mb12">事件</p>
                    <p class="fs12 line42" v-for="item in listData" :key="item.name">{{item.total}}</p>
                </section>
                <section class="ml4">
                    <p class="fs10 mb12">全部报道</p>
                    <p class="fs12 line42" v-for="item in listData" :key="item.name">{{item.forwardCount}}</p>
                </section>
            </div>
        </section>
        <img v-if="!listData.length" class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
    </div>
</template>

<script>
import utils from "@/util/common";
import _ from "loadsh";

export default {
    name: "EventStatsBar",
    props: {
        renderData: Object,
    },
    data() {
        return {
            listData: []
        }
    },
    mounted() {
        this.renderFunc()
    },
    watch:{
        "renderData": function (pre, cur){
            if(pre && cur)
                this.renderFunc()
        }
    },
    methods: {
        formatPercentStr(item, field){
            if(!item.total)
                return 0;
            return item[field];
        },
        renderFunc() {
            let {broadcastEffect, effectForwardCountsByTendency} = this.renderData;
            this.listData = _.each(broadcastEffect, item => {
                item.positivePer = utils.formatPercent(item.positive, item.total);
                item.neutralPer = utils.formatPercent(item.neutral, item.total);

                item.negativePer = 100 - item.positivePer - item.neutralPer;
                //!!保证正负中占比等于100%
                if(!item.negative && item.negativePer){
                    item.positive > item.neutral ? item.positivePer = item.positivePer + item.negativePer : item.neutralPer = item.neutralPer + item.negativePer;
                    item.negativePer = 0;
                }
                let info  = _.filter(effectForwardCountsByTendency, {affectLevel: item.level});
                item.forwardCount = _.sumBy(info, "value") || 0;

                // 事件总数为0时，均分占比
                if(!item.total){
                    item.positivePer = 34;
                    item.neutralPer = 33;
                    item.negativePer = 100 - item.positivePer - item.neutralPer;
                }
            });

            // 若data有不为0的情况，则过滤掉所有为0的item
            let targetData = _.filter(this.listData, item => {
                return item.negative || item.positive || item.neutral
            });

            if (targetData.length > 0)
                this.listData = targetData;
        },
        getMarginRight(item, type) {
            return item[type] < 12 ? (20 - item[type]) + 'px' : ''
        },
        getMarginLeft(item, type) {
            if (type === 'neutralPer') {
                if (item.positivePer >= 6 || !item.positivePer) {
                    return '';
                }
                return item.neutralPer <= 20 ? (item.positivePer - 33 + item.neutralPer) + 'px' : (item.positivePer - 20) + 'px';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.event_stats_bar {
    padding: 0 16px 20px 16px;
    .toolBox {

        //margin-bottom: 20px;
        p {
            margin-right: 7.4px;
            span:first-child {
                width: 5px;
                height: 4px;
                margin-right: 3px;
                border-radius: 50%;
            }
        }
    }
    .listItem { width: 96%; }
    .titleLabel, .lastText {
        width:30%;
    }
    .affect_stats{
        width: 71%;
    }
    .count_stats{
        width: 29%;
    }
    .topBarBox {
        width: 90%;
        height: 16px;
        border-radius: 8px;
        &.barBoxBg {
            background-color: #ffffff;
            overflow: hidden;
            p {
                height: 100%;
                &:nth-child(1) {
                    background-color: #FB7361;
                }
                &:nth-child(2) {
                    background-color: #FEBB32;
                }
                &:nth-child(3) {
                    background-color: #65DE8E;
                }
            }
            //.positivePerBox_1 {
            //    border-radius: 8px;
            //    border: 1PX solid hsl(0deg 5% 86%);
            //}
            //.positivePerBox_2 {
            //    border-radius: 0 8px 8px 0;
            //    border-top: 1PX solid hsl(0deg 5% 86%);
            //    border-bottom: 1PX solid hsl(0deg 5% 86%);
            //    border-right: 1PX solid hsl(0deg 5% 86%);
            //}
        }

        span {
            height: 100%;
        }
    }
    .lowerBarBox{
        width: 75%;
        height: 16px;
        border-radius: 8px;
        &.barBoxText {
            position: absolute;
            top: 28px;
            left: 24%;
        }
        span {
            height: 100%;
        }
    }
    .chartBox {
        position: relative;
        height: auto;

        .lineBox {
            width: 0;
            border-right: 1px dashed #C9C9CA;
            position: absolute;
            top: 35px;

            span {
                display: inline-block;
                width: 20px;
                text-align: center;
                font-size: 11px;
                position: absolute;
                bottom: -25px;
                right: -10px;
            }

            &:nth-child(1) {
                left: 0;
            }

            &:nth-child(2) {
                left: 50%;
            }

            &:nth-child(3) {
                left: 100%;
            }
        }

        .barBg {
            height: 16px;
            background-color: #376CCF;
            border-radius: 8px;
            margin-bottom: 18px;
            position: relative;

            span {
                position: absolute;
                right: -18px;
                line-height: 16px;
                font-size: 12px;
            }
        }

    }

}
</style>